import { Routes, Route } from 'react-router-dom'
import PortfolioPage from './pages/PortfolioPage'
import NotFoundPage from './pages/NotFoundPage'

function App() {
  return (
    <Routes>
      <Route path="/:uniqueId" element={<PortfolioPage />} />
      <Route path="/" element={<NotFoundPage message="Please provide a portfolio ID in the URL" />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default App
